import { Button } from 'components'
import { usePerformLogout } from 'providers/Auth0'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import { useTranslation } from 'react-i18next'

export const LogoutButton = ({ showToAllUsers }) => {
  const { t } = useTranslation()
  const logout = usePerformLogout()
  const isAdmin = useIsAdmin()

  const show = showToAllUsers || !isAdmin
  if (!show) return null

  return (
    <Button onClick={() => logout({ returnTo: window.location.origin })}>
      {t('dashboard.logout')}
    </Button>
  )
}

export default LogoutButton
